export const ASSETS = {
  ninjathleteLogo: "https://customer-assets-wrfwihn1.emergentagent.net/job_69ed5f38-b250-45fe-95d3-a31be3746172/artifacts/9sdu6j0a_Ninjathlete%202.webp",
};
export const LINKS = {
  ninjathlete: "https://ninjathlete.com",
};

export const CENTR_GEAR = {
  shopAll: "https://tidd.ly/3X1dZZq",
  bundles: [
    { name: "HYROX Men's Pro Bundle", href: "https://tidd.ly/3YHNskG", blurb: "The complete men's pro setup — official race weights, race standard, ready to train." },
    { name: "HYROX Women's Pro Bundle", href: "https://tidd.ly/45RoRxA", blurb: "The complete women's pro setup — official race weights for every station." },
    { name: "HYROX Power Bundle", href: "https://tidd.ly/4qkL3se", blurb: "The heavy-hitter kit for athletes chasing stronger sleds, carries and lunges." },
    { name: "HYROX Essentials Bundle", href: "https://tidd.ly/4qjvvVA", blurb: "The core pieces to start training the 8 stations without filling a garage." },
    { name: "HYROX Foundation Bundle", href: "https://tidd.ly/49SlyJ4", blurb: "The entry point — foundational gear to build your engine and learn the standards." },
  ],
  stations: [
    { name: "Sled", href: "https://tidd.ly/4o0815U", maps: "Sled Push · Sled Pull" },
    { name: "Sandbag", href: "https://tidd.ly/4pfPunk", maps: "Sandbag Lunges" },
    { name: "Kettlebells", href: "https://tidd.ly/45L0JwH", maps: "Farmers Carry" },
    { name: "Wall Balls", href: "https://tidd.ly/4r5MH1M", maps: "Wall Balls" },
    { name: "Ropes", href: "https://tidd.ly/3WXnWHn", maps: "Grip & conditioning" },
    { name: "Performance Turf", href: "https://tidd.ly/4r4Gcw1", maps: "Sled lanes & lunges" },
    { name: "Bumper Plates", href: "https://tidd.ly/3ZbEtZb", maps: "Sled loading" },
  ],
  machines: [
    { name: "Assault Treadmill", href: "https://tidd.ly/4aT0HX3", maps: "Compromised running" },
    { name: "Runr Treadmill", href: "https://tidd.ly/4jFpqQP", maps: "1km run intervals" },
    { name: "Home Gyms", href: "https://tidd.ly/4aYnqAZ", maps: "Full home setup" },
  ],
};
export const STAGES = [
  {
    n: "01",
    name: "Stage: Base",
    meta: "AUG 28 – SEPT 19 · WEEKS 1–4",
    start: "2026-08-28",
    end: "2026-09-19",
    definition: "The foundation of your fitness. Base training focuses on building aerobic endurance and overall fitness.",
    application: "During this phase, athletes engage in steady-state exercises that are low to moderate in intensity. This could involve longer runs, cycling, or rowing at a comfortable pace, allowing the body to adapt to sustained efforts. It helps improve cardiovascular efficiency and builds endurance that is crucial for the longer segments of the HYROX race.",
  },
  {
    n: "02",
    name: "Stage: Pace",
    meta: "SEPT 25 – OCT 17 · WEEKS 5–8",
    start: "2026-09-25",
    end: "2026-10-17",
    definition: "The speed or intensity at which you perform a specific workout.",
    application: "In HYROX training, pace refers to a controlled, steady effort that is sustainable for a defined period. This could be a specific target heart rate or a set speed for running or other exercises. Training at a set pace helps develop the body's ability to maintain speed over longer distances and is crucial for managing effort during the competition.",
  },
  {
    n: "03",
    name: "Stage: Accelerate",
    meta: "OCT 23 – OCT 31 · WEEKS 9–10",
    start: "2026-10-23",
    end: "2026-10-31",
    definition: "The phase of training that focuses on increasing speed and power.",
    application: "This involves high-intensity interval training (HIIT) or sprinting workouts that push the athlete to perform at higher intensities for shorter durations. The goal is to improve speed and explosiveness, which are critical for events like the sled push and burpee broad jumps in HYROX. Athletes may incorporate short bursts of all-out effort followed by recovery periods.",
  },
  {
    n: "04",
    name: "Stage: Prime",
    meta: "NOV 6 – NOV 14 · WEEKS 11–12",
    start: "2026-11-06",
    end: "2026-11-14",
    definition: "The state of being optimally prepared for performance, both physically and mentally.",
    application: "In training, priming refers to workouts that prepare the body for higher-intensity efforts or competitions. This can include race simulations or specific workout strategies that mimic race conditions. Priming helps athletes practice pacing, transitions, and recovery strategies to enhance overall performance on race day.",
  },
  {
    n: "05",
    name: "Race Week",
    meta: "WEEK 13",
    start: "2026-11-15",
    end: "2026-11-21",
    definition: "The final week before competition, when training volume drops and race readiness becomes the priority.",
    application: "Complete a light shake-out session, prioritize recovery, hydration and sleep, prepare your equipment, and arrive ready to execute the pacing and movement strategies developed throughout the program.",
  },
];
export const getStageStatus = () => {
  const t = Date.now();
  for (let i = 0; i < STAGES.length; i++) {
    const s = new Date(`${STAGES[i].start}T00:00:00-05:00`).getTime();
    const e = new Date(`${STAGES[i].end}T23:59:59-05:00`).getTime();
    if (t >= s && t <= e) return { index: i, label: "current" };
    if (t < s) return { index: i, label: "next" };
  }
  return null;
};
export const DIVISIONS = [
  { key: "openW", label: "Open Women" },
  { key: "openM", label: "Open Men" },
  { key: "proW", label: "Pro Women" },
  { key: "proM", label: "Pro Men" },
];
export const STATIONS = [
  {
    n: "01",
    name: "SkiErg",
    metric: "1,000m",
    focus: "Lats · Core · Cardio Pacing",
    details:
      "High-cadence upper-body ergometer test. Lock into a steady stroke rhythm without blowing out your heart rate — Run 2 is waiting.",
    weights: { openW: "1,000m", openM: "1,000m", proW: "1,000m", proM: "1,000m" },
  },
  {
    n: "02",
    name: "Sled Push",
    metric: "50m (4 × 12.5m)",
    focus: "Quad Power · Hip Drive · Grit",
    details:
      "Total leg drive across 4 carpet lanes. The sled must fully cross the line before each pivot. Low hips, short violent steps.",
    weights: {
      openW: "102 kg / 225 lbs",
      openM: "152 kg / 335 lbs",
      proW: "152 kg / 335 lbs",
      proM: "202 kg / 445 lbs",
    },
  },
  {
    n: "03",
    name: "Sled Pull",
    metric: "50m (4 × 12.5m)",
    focus: "Posterior Chain · Grip · Biceps",
    details:
      "Rope pull inside the box boundary — feet may not cross the forward line. Use your hips and bodyweight, not just your arms.",
    weights: {
      openW: "78 kg / 172 lbs",
      openM: "103 kg / 227 lbs",
      proW: "103 kg / 227 lbs",
      proM: "153 kg / 337 lbs",
    },
  },
  {
    n: "04",
    name: "Burpee Broad Jump",
    metric: "80m",
    focus: "Aerobic Threshold · Plyo Endurance",
    details:
      "Chest to deck, then an explosive two-footed broad jump forward. No steps between reps. Pace it — this station wrecks the unprepared.",
    weights: { openW: "80m", openM: "80m", proW: "80m", proM: "80m" },
  },
  {
    n: "05",
    name: "Rowing",
    metric: "1,000m",
    focus: "Full-Body Rhythm · Leg Drive",
    details:
      "1,000m on the Concept2 erg. The halfway checkpoint of your race — manage the lactic, breathe, and hold your split.",
    weights: { openW: "1,000m", openM: "1,000m", proW: "1,000m", proM: "1,000m" },
  },
  {
    n: "06",
    name: "Farmers Carry",
    metric: "200m",
    focus: "Grip · Traps · Core Stiffness",
    details:
      "Dual kettlebell carry over 200m. The clock keeps running if you set them down. Tall posture, fast feet, iron grip.",
    weights: {
      openW: "2 × 16 kg / 35 lbs",
      openM: "2 × 24 kg / 53 lbs",
      proW: "2 × 24 kg / 53 lbs",
      proM: "2 × 32 kg / 70 lbs",
    },
  },
  {
    n: "07",
    name: "Sandbag Lunges",
    metric: "100m",
    focus: "Glutes · Hamstrings · Balance",
    details:
      "Sandbag over the shoulders, lunging 100m. Trailing knee gently touches the turf every stride. Relentless, one step at a time.",
    weights: {
      openW: "10 kg / 22 lbs",
      openM: "20 kg / 44 lbs",
      proW: "20 kg / 44 lbs",
      proM: "30 kg / 66 lbs",
    },
  },
  {
    n: "08",
    name: "Wall Balls",
    metric: "75–100 reps",
    focus: "Shoulder Stamina · Squat Depth",
    details:
      "The final boss. Deep squat below parallel into a high target hit, under supreme fatigue. Finish line is on the other side.",
    weights: {
      openW: "75 reps @ 4 kg · 2.7m",
      openM: "100 reps @ 6 kg · 3.0m",
      proW: "100 reps @ 6 kg · 2.7m",
      proM: "100 reps @ 9 kg · 3.0m",
    },
  },
];
export const MERCH = [
  {
    id: "214-tee",
    name: "214 Reunion Tower Tee",
    tag: "City Code Series",
    img: "https://static.prod-images.emergentagent.com/jobs/69ed5f38-b250-45fe-95d3-a31be3746172/images/d169d70879b661feb6fff94da7753c1bb0feee5e7250894d86c85d21c8c14ac8.jpeg",
  },
  {
    id: "skyline-tee",
    name: "214 Skyline Tee — White",
    tag: "City Code Series",
    img: "https://static.prod-images.emergentagent.com/jobs/69ed5f38-b250-45fe-95d3-a31be3746172/images/da95c7f1bc0cf86f91758ef1bece6a4cd7df45eb8b8d02e7d1a879d3cd004695.jpeg",
  },
  {
    id: "ninja-hoodie",
    name: "NinjAthlete Shuriken Hoodie",
    tag: "Co-Brand Series",
    img: "https://static.prod-images.emergentagent.com/jobs/69ed5f38-b250-45fe-95d3-a31be3746172/images/4480ea9b6a29da570b15bd546e7bd31fd21c57e1d04ff76ef83e60c8ca165aab.jpeg",
  },
  {
    id: "stations-ls",
    name: "8×8 Race Card Long Sleeve",
    tag: "Race Series",
    img: "https://static.prod-images.emergentagent.com/jobs/69ed5f38-b250-45fe-95d3-a31be3746172/images/b8a0438390bffa0f378e5a733ad566d60f4a4dd0e0d4f398e8641040b57d4fee.jpeg",
  },
  {
    id: "sled-tee",
    name: "HYROX NINJA Sled Tee",
    tag: "Race Series",
    img: "https://static.prod-images.emergentagent.com/jobs/69ed5f38-b250-45fe-95d3-a31be3746172/images/6850371a728701c4175b9b3079226e344a07fa3ca3bbd6fad88785a45e73befa.jpeg",
  },
  {
    id: "214-cap",
    name: "214 Shuriken Cap",
    tag: "City Code Series",
    img: "https://static.prod-images.emergentagent.com/jobs/69ed5f38-b250-45fe-95d3-a31be3746172/images/ee5d9a82b8113603013e0f964aba785a2f0b2919eccb11ebfb8c31980454f67c.jpeg",
  },
];
export const DPS_BASE = "https://www.dropbox.com/scl/fo/9hwuayx0fdcrtn7lrvk1j";
export const DPS_RLKEY = "u5geod5xtbhngx22fh2ozokui";
const dpsClip = (fid, num) =>
  `${DPS_BASE}/${fid}/Color%20Graded%20Clips${num}.mov?rlkey=${DPS_RLKEY}&raw=1`;
export const DPS_CLIPS = [
  ["AMxQ4UpiELXfLqYrfz3cSB8", "00647507"],
  ["AFXzos0f4wYuchqGwSwTx3M", "00647841"],
  ["AMzUQBn6_9QOqmx7erIhWNs", "00648461"],
  ["AOTdpJPVV5eyFv2CQZzcAlg", "00649262"],
  ["AG2ayD2dDEnfWSf6uHhWlP8", "00649659"],
  ["AIHKujLqBDHURVu1KI45bQs", "00650499"],
  ["AHJj0kIejs6jyA-QX_LVhKM", "00650851"],
  ["ADTE9v6RJjYm94cCDKfo6sc", "00651802"],
  ["AD7yOcPuX-tqsVVXXwx7854", "00652415"],
  ["AP59zDGdhZ64a2VC8NHo_WQ", "00652763"],
  ["AC9XcSs9FoBHFuxUNI9050g", "00653149"],
  ["AIRFfk7WYZnxSlnZtWTPClI", "00653451"],
  ["APLIPRRskWlzISMhGWP9Zj0", "00654172"],
  ["AAO3NdpxSyPn5T_8sGu5KIQ", "00654538"],
  ["AOUX4CmDBItSDi2mZJpKLME", "00655082"],
  ["AC1g168g8xdeDlSzPFm6o74", "00655694"],
  ["ANoRlyNTskKQnZ7EycVtazk", "00657093"],
  ["AAKD7jv953VGnt5vzcH_pLo", "00657969"],
  ["AHH97bm_ANIga-IDTYCELs4", "00660809"],
].map(([fid, num], i) => ({
  id: num,
  label: `DPS Session · ${String(i + 1).padStart(2, "0")}`,
  src: dpsClip(fid, num),
  thumb: `/dps/thumb-${num}.jpg`,
}));
export const DPS_MEDIA = {
  heroVideo: dpsClip("AIHKujLqBDHURVu1KI45bQs", "00650499"),
  heroPoster: "/dps/poster-home.jpg",
  featured: dpsClip("AIHKujLqBDHURVu1KI45bQs", "00650499"),
  teaser: dpsClip("AMxQ4UpiELXfLqYrfz3cSB8", "00647507"),
  group: dpsClip("AHH97bm_ANIga-IDTYCELs4", "00660809"),
  groupPoster: "/dps/poster-group.jpg",
  strip: [
    dpsClip("AOTdpJPVV5eyFv2CQZzcAlg", "00649262"),
    dpsClip("AC9XcSs9FoBHFuxUNI9050g", "00653149"),
    dpsClip("AMxQ4UpiELXfLqYrfz3cSB8", "00647507"),
  ],
  bg: {
    home: "/dps/bg-home2.jpg",
    stations: "/dps/bg-stations.jpg",
    schedule: "/dps/bg-schedule.jpg",
    events: "/dps/bg-events.jpg",
    program: "/dps/bg-program.jpg",
    simulation: "/dps/bg-simulation.jpg",
    simFormat: "/dps/bg-simformat.jpg",
    thursdays: "/dps/poster-hero.jpg",
  },
};
export const MARQUEE_ITEMS = [
  "HYROX DALLAS",
  "8KM RUN",
  "8 STATIONS",
  "DPS × NINJATHLETE",
  "DALLAS 214",
  "FULL SIMULATION",
  "HYROXNINJA.COM",
];
